module.exports = __webpack_public_path__ + "static/media/sales-order-slide-6.3138574a.jpg";